/**
 * MAHI — standalone app shell.
 *
 * `MahiApp` now mounts at the domain root (`/*`) rather than under a
 * `/mahi/*` prefix. That prefix was a leftover of `MahiApp` once being one
 * route among many inside the larger Nanokart platform bundle it was
 * extracted from — MAHI has been the only thing in this app for a while, and
 * the prefix had stopped meaning anything except a longer URL: `mahi.fashion`
 * is already MAHI, so `mahi.fashion/mahi/wardrobe` said it twice.
 *
 * MahiApp's own internal routes are relative (`path="wardrobe"`, not
 * `path="/mahi/wardrobe"`), so mounting it here at `/*` instead of `/mahi/*`
 * is the only change it needed — everything under it now resolves one
 * segment shorter for free.
 *
 * The two legacy redirects below exist because `/mahi/...` links do not stop
 * being real the day this ships: a partner-verification email already sent,
 * a bookmarked wardrobe link, a buy-click fallback token minted moments
 * before deploy. Both forward to the un-prefixed shape rather than 404ing
 * into MahiApp's own not-found handling, and both preserve the query string
 * — the buy-click fallback specifically depends on that surviving the hop.
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MahiApp from './mira/MahiApp';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/mahi/*"
          element={<Navigate to={window.location.pathname.replace(/^\/mahi/, '') + window.location.search} replace />}
        />
        <Route
          path="/mira/*"
          element={<Navigate to={window.location.pathname.replace(/^\/mira/, '') + window.location.search} replace />}
        />
        <Route path="/*" element={<MahiApp />} />
      </Routes>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#ffffff',
            color: '#0f172a',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
          },
          success: {
            iconTheme: { primary: '#2563eb', secondary: '#ffffff' },
          },
          error: {
            iconTheme: { primary: '#dc2626', secondary: '#ffffff' },
          },
        }}
      />
    </Router>
  );
}

export default App;
